import { CSSProperties, SVGProps } from 'react'
import Colors from 'modules/Colors'

interface SpotifyFlatIconProps extends SVGProps<SVGSVGElement> {
    className?: string
    style?: CSSProperties
    color?: string
    size?: number
    onClick?: () => void
}

const SpotifyFlatIcon = ({
    className,
    style,
    color = Colors.purple,
    size = 40,
    onClick
}: SpotifyFlatIconProps) => {
    return (
        <svg
            className={className}
            style={style}
            width={size}
            height={size}
            onClick={onClick}
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_181_140)">
                <path
                    d="M19.9992 4.05276C11.1899 4.05276 4.04819 11.1943 4.04819 20.0036C4.04819 28.8133 11.1899 35.9543 19.9992 35.9543C28.8095 35.9543 35.9505 28.8133 35.9505 20.0036C35.9505 11.1949 28.8095 4.05352 19.999 4.05352L19.9992 4.05276V4.05276ZM27.3143 27.0585C27.0286 27.527 26.4152 27.6756 25.9467 27.388C22.2015 25.1004 17.4869 24.5823 11.9345 25.8509C11.3994 25.9728 10.8661 25.6375 10.7442 25.1023C10.6217 24.567 10.9556 24.0337 11.492 23.9118C17.5682 22.523 22.7802 23.1213 26.9848 25.6909C27.4533 25.9785 27.6019 26.5899 27.3143 27.0585V27.0585ZM29.2667 22.7147C28.9067 23.3004 28.1409 23.4851 27.5562 23.1251C23.2686 20.4891 16.7328 19.7259 11.6613 21.2653C11.0036 21.464 10.3089 21.0933 10.1093 20.4368C9.91124 19.779 10.2821 19.0857 10.9387 18.8857C16.7316 17.128 23.9333 17.9794 28.8571 21.0051C29.4419 21.3651 29.6267 22.1309 29.2667 22.7149V22.7147ZM29.4343 18.192C24.2933 15.1385 15.8114 14.8577 10.903 16.3474C10.1149 16.5865 9.28133 16.1415 9.04247 15.3533C8.80362 14.5648 9.24819 13.7318 10.0369 13.4922C15.6714 11.7817 25.0381 12.1122 30.9569 15.6259C31.6674 16.0467 31.8998 16.9623 31.4789 17.6703C31.0598 18.3792 30.1417 18.613 29.435 18.192H29.4343Z"
                    fill={color}
                />
            </g>
            <defs>
                <clipPath id="clip0_181_140">
                    <rect width="32" height="32" fill="white" transform="translate(4 4)" />
                </clipPath>
            </defs>
        </svg>
    )
}

export default SpotifyFlatIcon
